<h2 class="text-center"> Forgot your password?</h2>
<div class="row">
  <div class="col-sm-4">
    <img src="/assets/images/forgot_pass.png" width="100%">
  </div>
  <div class="col-sm-6">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="mt-5 bt-5">

      <div class="form-group row input-group-lg">
          <div class="col-sm-12">
            <p>Please enter the email address you'd like your password reset information sent to. This should be the same as your username</p>
          <input placeHolder="Email" type="text" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': f.email.errors && f.email.touched }" />
          <div *ngIf="f.email.errors && f.email.touched" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">Email is required</div>
          </div>
          </div>
          </div>
          <div class="form-group row input-group-lg">
          <div class="col-sm-12 mt-4 text-center">
              <button [disabled]="loading" class="btn btn-primary btn-lg">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                  Request Reset link
              </button>
          </div>
      </div>

  </form>


  </div>
</div>

